import { Divider, Layout } from 'antd';
import React from 'react';

const { Footer } = Layout;

const Footered = () => {
  return (
    <Footer
      style={{
        // background: '#f',
        color: 'black',
        paddingLeft: 0,
        paddingRight: 0,
        textAlign: 'center',
      }}
    >
      {/* <Row gutter={24} className='footer'>
        <Col xs={24} sm={24} md={6}>
          <h2>相关资源</h2>
          <div>Ant Design</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
        </Col>

        <Col xs={24} sm={24} md={6}>
          <h2>社区</h2>
          <div>Ant Design</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
        </Col>

        <Col xs={24} sm={24} md={6}>
          <h2>帮助</h2>
          <div>Ant Design</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
        </Col>

        <Col xs={24} sm={24} md={6}>
          <h2>更多产品</h2>
          <div>Ant Design</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
          <div>Ant Design Mobile</div>
        </Col>
      </Row> */}
      {/* <Divider className='line' /> */}
      <p className='line_footer'>Copyright 2020 链平方出品</p>
    </Footer>
  );
};
export default Footered;
